import axios from "axios"

function processFile({}, values) {
    return axios.post(`/api/v1/school-card-report`, values)
}

function getAnalysisDataByHash({ hash }) {
    return axios.get(`/api/v1/school-card-report/analysis/${hash}`)
}

function updateReportEmailByHash({}, { email, hash }) {
    return axios.patch(`/api/v1/school-card-report/email`, { email, hash })
}

export const schoolCardReportService = {
    processFile,
    getAnalysisDataByHash,
    updateReportEmailByHash,
}
